<template>
	<header class=" m-header-flag">
		<div class="m-header-flag__inner">
			<img src="../assets/img/seo_company.png" alt="Logo">
		</div>
	</header>
</template>

<script>
	export default {
		name: "mHeaderFlag.vue"
	}
</script>

<style scoped>
	.m-header-flag {
		line-height: 0;
		width: 150px;
		height: 100px;
		text-align: center;
	}
	.m-header-flag .m-header-flag__inner{
		box-sizing: border-box;
		position: relative;
		background: #fff;
		-webkit-box-shadow: 0 0 19.44px 4.56px rgba(154,158,171,.18);
		box-shadow: 0 0 19.44px 4.56px rgba(154,158,171,.18);
	}
	.m-header-flag .m-header-flag__inner img{
		width: 118px;
		padding: 12px 0px 20px;
	}
	.m-header-flag .m-header-flag__inner:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: -24px;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 0 75px 25px 75px;
		border-color: transparent #fff transparent #fff;
	}
</style>